module.exports = __webpack_public_path__ + "images/feature/20160720_1-cf2470fa5bbe9f8d3acb2e859338630d.jpg";